var _circle, _circle2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _path, _path2, _path3, _path4, _ellipse13, _ellipse14, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 102,
    r: 80,
    fill: "#00FFFF",
    opacity: 0.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 98,
    r: 80,
    fill: "#FF00FF",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 88,
    rx: 13,
    ry: 8,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(-40 34 88)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 90,
    rx: 13,
    ry: 8,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(-40 37 90)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 106,
    rx: 13,
    ry: 8,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(-20 28 106)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 108,
    rx: 13,
    ry: 8,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(-20 31 108)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 124,
    rx: 13,
    ry: 8,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(10 28 124)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 126,
    rx: 13,
    ry: 8,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(10 31 126)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 140,
    rx: 12,
    ry: 7,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(30 38 140)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41,
    cy: 142,
    rx: 12,
    ry: 7,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(30 41 142)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166,
    cy: 90,
    rx: 12,
    ry: 8,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(38 166 90)"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169,
    cy: 92,
    rx: 12,
    ry: 8,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(38 169 92)"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 110,
    rx: 12,
    ry: 8,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(18 170 110)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173,
    cy: 112,
    rx: 12,
    ry: 8,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(18 173 112)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164,
    cy: 128,
    rx: 12,
    ry: 7,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 2,
    transform: "rotate(-10 164 128)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167,
    cy: 130,
    rx: 12,
    ry: 7,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(-10 167 130)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 80 Q70 64 100 62 Q130 64 158 82",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 82 Q73 66 103 64 Q133 66 161 84",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 148 Q70 160 100 162 Q130 160 158 148",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 150 Q73 162 103 164 Q133 162 161 150",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 112,
    rx: 55,
    ry: 52,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 115,
    rx: 55,
    ry: 52,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106 L84 100 L86 106 L92 106 L87 110 L89 116 L84 112 L79 116 L81 110 L76 106 Z",
    fill: "#CC00CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108 L87 102 L89 108 L95 108 L90 112 L92 118 L87 114 L82 118 L84 112 L79 108 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 104 L116 98 L118 104 L124 104 L119 108 L121 114 L116 110 L111 114 L113 108 L108 104 Z",
    fill: "#CC00CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117 106 L119 100 L121 106 L127 106 L122 110 L124 116 L119 112 L114 116 L116 110 L111 106 Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72 132 Q100 156 134 136",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75 134 Q103 158 137 138",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 52,
    width: 5,
    height: 5,
    fill: "#FFD700",
    opacity: 0.9,
    transform: "rotate(20 56 54)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 54,
    width: 5,
    height: 5,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(20 59 56)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 48,
    width: 4,
    height: 4,
    fill: "#FF00FF",
    opacity: 0.9,
    transform: "rotate(-15 138 50)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 50,
    width: 4,
    height: 4,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1,
    transform: "rotate(-15 141 52)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 60,
    width: 5,
    height: 5,
    fill: "#FFD700",
    opacity: 0.8,
    transform: "rotate(35 150 62)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 62,
    width: 4,
    height: 4,
    fill: "#FF6600",
    opacity: 0.8,
    transform: "rotate(-25 46 64)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 64,
    width: 4,
    height: 4,
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 1,
    transform: "rotate(-25 49 66)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 195,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#FF00FF",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 2
  }, "FINISHED")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 197,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "#00CCCC",
    textAnchor: "middle",
    fontWeight: "bold",
    letterSpacing: 2,
    opacity: 0.45
  }, "FINISHED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.b11f43785bd7aa4446cda282d4f6bdda.svg";
export { ForwardRef as ReactComponent };